export interface PollOption {
  id: string
  label: string
  order_index: number
  is_other: boolean
  config?: Record<string, any>
}

export interface PollStep {
  id: string
  title: string
  description: string | null
  order_index: number
}

export interface PollQuestion {
  id: string
  step_id: string | null
  type: 'checkbox' | 'radio' | 'text' | 'select' | 'switch' | 'number' | 'textarea'
  title: string
  subtitle: string | null
  is_required: boolean
  order_index: number
  config: Record<string, any>
  options: PollOption[]
}

export interface Poll {
  id: string
  title: string
  description: string | null
  is_default: boolean
  steps: PollStep[]
  questions: PollQuestion[]
}

export interface PollAnswerItem {
  question_id?: string
  system_key?: string | null
  question: string
  answer: string | string[] | number | boolean | null
  answer_labels?: string | string[] | null
  field_type: string
}

export interface PollSetupStage {
  key: string
  title: string
  status: 'pending' | 'running' | 'done' | 'error'
  error?: string | null
}

export interface PollSetupRun {
  id: string
  poll_id: string
  tenant_id: string
  status: 'pending' | 'running' | 'done' | 'error'
  stages: PollSetupStage[]
  error?: string | null
}

export interface PollSubmission {
  id: string
  poll_id: string
  tenant_id: string
  submitted_by: string | null
  status: 'started' | 'completed'
  answers: PollAnswerItem[]
  setup?: PollSetupRun | null
  created_at: string
  updated_at: string
  completed_at: string | null
}

/** Данные с формы регистрации кабинета (только для владельца) */
export interface PollRegistrationProfile {
  contact_name: string | null
  company_name: string | null
}

export interface PollAccessState {
  needs_poll: boolean
  is_tenant_owner: boolean
  submission: PollSubmission | null
  setup: PollSetupRun | null
  registration?: PollRegistrationProfile | null
}

export type PollFormValue = string | string[] | number | boolean | null

export function getOptionValue(option: PollOption): string {
  const code = option.config?.code
  return typeof code === 'string' && code.trim() ? code.trim() : option.id
}

export function isQuestionLocked(question: PollQuestion): boolean {
  return question?.config?.locked === true
}

export function isOptionLocked(option: PollOption): boolean {
  return option?.config?.locked === true
}

export function isOptionRequired(option: PollOption): boolean {
  return option?.config?.required === true
}
